import React from "react";

/**
 * Global site footer — links mirror the public maitree-ev.org navigation
 * (Home, Past Events, Focus Areas) plus the legal pages the app already
 * references elsewhere (Satzung, Privacy Statement, Impressum, Contact).
 * Hidden on admin/system routes to avoid visual clutter inside the
 * portals; shown everywhere else via App.js.
 */
const SITE_LINKS = [
  { label: "Home", href: "https://maitree-ev.org/" },
  { label: "Past Events", href: "https://maitree-ev.org/index.php/past-events" },
  { label: "Focus Areas", href: "https://maitree-ev.org/index.php/focus-areas" },
  { label: "Satzung", href: "https://maitree-ev.org/satzung/" },
  { label: "Privacy Statement", href: "https://maitree-ev.org/privacy-statement-eu/?cmplz_region_redirect=true" },
  { label: "Impressum", href: "https://maitree-ev.org/impressum/" },
  { label: "Contact", href: "https://maitree-ev.org/contact/" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 bg-white/70 backdrop-blur-sm"
    >
      <div className="max-w-6xl mx-auto px-6 py-8">
        <nav
          aria-label="Site footer navigation"
          className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm"
        >
          {SITE_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-600 hover:text-[#1e3a5f] hover:underline font-medium transition-colors"
              data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <p className="mt-6 text-center text-xs text-slate-500">
          &copy; {year} Maitree e.V. &middot; Celebrating the essence of life
        </p>
      </div>
    </footer>
  );
}
